import { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const StaffManager = () => {
  const [staff, setStaff] = useState([]);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const load = () => api.get("/admin/staff").then((r) => setStaff(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!email.trim() || !password.trim()) { toast.error("Enter email and password"); return; }
    try {
      await api.post("/admin/staff", { email, password });
      toast.success("Staff account created");
      setEmail(""); setPassword(""); load();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  const del = async (id) => {
    try { await api.delete(`/admin/staff/${id}`); toast.success("Removed"); load(); }
    catch { toast.error("Delete failed"); }
  };

  return (
    <div className="max-w-2xl" data-testid="staff-manager">
      <div className="card-dark p-6 sm:p-8">
        <h3 className="font-serif text-xl font-semibold">Add Staff (Scanner) Account</h3>
        <p className="mt-1 text-sm text-zinc-400">Staff can only log in and scan / verify tickets. They cannot access events, bookings or settings.</p>
        <div className="mt-5 grid gap-3 sm:grid-cols-2">
          <input className="input-field" placeholder="staff@email.com" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="staff-email-input" />
          <input className="input-field" placeholder="Password" type="text" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="staff-password-input" />
        </div>
        <button onClick={add} className="btn-gold mt-4 !py-2.5 text-sm" data-testid="add-staff-button"><Plus size={15} /> Create Staff</button>
      </div>

      <div className="mt-6 space-y-2">
        {staff.map((s) => (
          <div key={s.id} className="card-dark flex items-center justify-between p-4" data-testid={`staff-row-${s.id}`}>
            <div>
              <p className="font-medium">{s.email}</p>
              <p className="text-xs text-zinc-500">Staff · Scanner access</p>
            </div>
            <button onClick={() => del(s.id)} className="text-red-400" data-testid={`delete-staff-${s.id}`}><Trash2 size={16} /></button>
          </div>
        ))}
        {!staff.length && <p className="text-sm text-zinc-500">No staff accounts yet.</p>}
      </div>
    </div>
  );
};
